var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-detail"},[_c('Header',{attrs:{"title":"资讯详情","is-nav":true}}),_c('div',{staticClass:"message-scroll"},[_c('MessageContent',{attrs:{"message":_vm.message}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }